const dataUtility = {
  features: [
    {
      text: 'Flori - Cadouri - Emoții',
      icon: 'fas fa-gift'
    },{
      text:  'De Luni - Duminică',
      icon: 'far fa-calendar'
    },{
      text:  'Livrare Rapidă',
      icon: 'fas fa-shipping-fast'
    },{
      text:  'Profesionalism 100%',
      icon: 'fas fa-user-tie'
    }
  ]
};

export default dataUtility;
